/**
 * @param {import('../types/SalesMetro.api').ISalesMetroApiModel} model
 * @returns {import('../types/SalesMetro').ISalesMetro}
 */
export const toSalesMetro = (model) => ({
  id: model.id,
  name: model.name ?? '',
  assignedInternalUserIds: model.assignedInternalUserIds ?? [],
});

/**
 * Maps a page of API rows to sales metros, dropping any row without an id.
 *
 * The reserved "Unassigned" row is kept: it is a valid metro, the one an office
 * whose zip is in no metro is assigned to. Whether the portal may offer it yet
 * is the RAM list's decision (`getSalesMetros` thunk), not the API shape's.
 *
 * @param {import('../types/SalesMetro.api').ISalesMetroApiModel[]} items
 * @returns {import('../types/SalesMetro').ISalesMetro[]}
 */
export const toSalesMetros = (items) =>
  (items || []).filter((model) => model?.id).map(toSalesMetro);

export const SalesMetroAdapters = {
  toSalesMetro,
  toSalesMetros,
};
